import React from 'react'

type Props = {
  label: any
  onChange?: any
  id: any
  parentId?: any
  level?: any
  labelClass?: any
  icon?: any
  name?: any
  inputClass?: any
  value?: any
  checked?:any
  divclass?:any
  disabled?:any
}

export function Checkbox({
  label,
  onChange,
  id,
  parentId,
  level,
  labelClass,
  icon,
  name,
  inputClass,
  value,
  checked,
  divclass,
  disabled
}: Props) {
  return (
    <>
      <div className={divclass}>
        <label htmlFor={id} className={`${labelClass} flex items-center space-x-3`}>
          <input
          disabled={disabled}
            type='checkbox'
            id={id}
            name={name}
            onChange={onChange}
            value={value}
            checked={checked}
            data-level={level}
            data-parentid={parentId}
            className={`w-4 h-4 text-blue-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500 focus:ring-2 ${inputClass}`}
          />
          {icon}
         <span> {label}</span>
        </label>
      </div>
    </>
  )
}

Checkbox.defaultProps = {
  label: 'Default Labe',
  labelClass: 'ml-2',
  
}
